import React from "react";
import { Button, Input, Modal } from "@/ui";
import { omit } from "../../utils/utils";
import { useMutation } from "@apollo/react-hooks";
import useMeta from "../../base/hooks/useMeta";
import useForm from "../../base/hooks/form/useForm";
import useValidator from "../../base/hooks/form/useValidator";
import useNotification from "../../base/hooks/components/useNotification";
import {
    MUTATION_CREATE_STORE_ASYNC,
    QUERY_STORES_FROM_ACCOUNT_LIST,
} from "../../apollo/module-operations/store";
import deliveryStyles from "../store/DeliverySchedules.module.scss";
import styles from "../store/ItemFormModal.module.scss";

const fieldError = (validator, name) =>
    validator?.[name]?.isInvalid ? validator[name].message : undefined;

const StoreFormModal = ({ isOpen, toggle }) => {
    const { resourceId, user } = useMeta();

    const { inputs, inputChange } = useForm();

    const notify = useNotification();

    const { validator, isValid, isSubmited } = useValidator(
        [
            {
                field: "name",
                method: "isEmpty",
                validWhen: false,
                message: "This name is required.",
            },
        ],
        {
            ...inputs,
        },
    );

    let options = {
        variables: {
            account_id: resourceId,
            input: inputs,
        },
    };

    const [mutateCreateStore, { loading: createStoreLoading }] = useMutation(
        MUTATION_CREATE_STORE_ASYNC,
        {
            refetchQueries: [
                {
                    query: QUERY_STORES_FROM_ACCOUNT_LIST,
                    variables: {
                        account_id: user.accountId,
                    },
                },
            ],
            onCompleted: () => {
                toggle(false);
                notify("Store Created Successfully", "success");
            },
            onError: () => {
                notify("Error Creating The Store", "error");
            },
        },
    );

    const createStore = async () => {
        if (isSubmited) {
            isSubmited(true);
        }

        if (isValid()) {
            options = omit(options);
            mutateCreateStore(options);
        }
    };

    const cancel = () => {
        toggle(false);
    };

    return (
        <Modal
            assistiveDescription="Create a new store for this account"
            footer={
                <div className={deliveryStyles.modalActions}>
                    <Button
                        loading={createStoreLoading}
                        onClick={createStore}
                        type="button"
                    >
                        Create
                    </Button>
                    <Button
                        disabled={createStoreLoading}
                        onClick={cancel}
                        type="button"
                        variant="secondary"
                    >
                        Cancel
                    </Button>
                </div>
            }
            onOpenChange={open => toggle(open)}
            open={isOpen}
            size="sm"
            title="Create Store"
        >
            <div className={styles.fields}>
                <Input
                    error={fieldError(validator, "name")}
                    fullWidth
                    label="Store Name *"
                    name="name"
                    onChange={inputChange}
                    placeholder="Store Name"
                    value={inputs.name || ""}
                />
            </div>
        </Modal>
    );
};

export default StoreFormModal;
